<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">L/G Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="lg_fee" type="text" placeholder="L/G fee" :class="{ 'is-danger': errors.lg_fee }">
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                    <p v-if="errors.lg_fee" class="help is-danger">{{ errors.lg_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            lg_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.lg_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'lg_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/LgFeeInput.vue